import { CategoryFacetViewModel } from '@/types/api';
import { getBaseURL } from '@/features/navigation/utils/url-helpers';
import { AppNextLink } from '@/features/app-next-link';
import { PLPPages } from '@/app/(plp)/types';
import { toNumberCommas } from '@/utils/string-helpers';
interface Props {
  categories: CategoryFacetViewModel[];
  title?: string;
}
const DesktopCategories = ({
  categories,
  title
}: Props) => {
  return <div className='mb-3 flex flex-col text-body-14' data-sentry-component="DesktopCategories" data-sentry-source-file="desktop.tsx">
            {title && <span className='px-4 py-2 font-bold'>{title}</span>}
            {categories?.map(category => {
      return <AppNextLink prefetch={false} className='flex flex-wrap items-center gap-0.5 px-4 py-2' key={category.key} href={'/' + getBaseURL({
        page: PLPPages.Categories,
        basicMetas: {
          breadcrumb: category.breadcrumb
        }
      })}>
                        {category.displayNameFa}
                        <span className='text-text-darkGray'>
                            {category.count ? `(${toNumberCommas(category.count)})` : ''}
                        </span>
                    </AppNextLink>;
    })}
        </div>;
};
export default DesktopCategories;